import React from "react";

function PropertyLaw() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Property Law</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              Nabeel Saeed Law Firm provides all property law related services such as advising and handling the entire process and procedure of the sale and purchase of property.  The Firm also handles property related disputes before the Rental Disputes Committee in the Kingdom of Bahrain including but not limited to filing cases for unpaid rent and eviction of tenants
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default PropertyLaw;
